import { useEffect } from 'react';
import { useCurrentUser } from 'FrontRoyalAngular';

/*
    Calls the handler on Enter anywhere on the page. It does nothing if the user turned off keyboard
    shortcuts, if a modifier key is held, or while the student types or a modal is open.
*/
export function useEnterKeyPress(onPress: () => void, enabled = true) {
    const currentUser = useCurrentUser();
    const keyboardShortcutsEnabled = !currentUser || currentUser.prefKeyboardShortcuts;

    useEffect(() => {
        if (!enabled || !keyboardShortcutsEnabled) return undefined;

        const handler = (event: KeyboardEvent) => {
            if (event.key !== 'Enter' || event.metaKey || event.ctrlKey || event.altKey) return;
            if (document.body.classList.contains('modal-open')) return;

            const target = event.target as HTMLElement | null;
            if (target?.closest('input, textarea, [contenteditable="true"]')) return;

            onPress();
        };

        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [onPress, enabled, keyboardShortcutsEnabled]);
}
